import React from 'react';
import {
    Button,
    Grid,
    Paper,
  } from "@material-ui/core";
import { CboCentrosMedicos } from '../../cbos/CboCentrosMedicos';
import { CboProfesionales } from '../../cbos/CboProfesionales';
import { CboEspecialidades } from '../../cbos/CboEspecialidades';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import esLocale from "date-fns/locale/es";
import moment from "moment";

export const ParametrosConsultaBaja = (props) => {
    const { handleInputChangeCascada, classes, idCentroMedico, idProfesional, setIdEspecialidad, idEspecialidad } = props;
    const { fechaDesde, fechaHasta, setearValor } = props;
  
    return ( 
        <>
            <Grid container direction="row" alignItems="center">
                <Grid item xs={12} md={4}>
                    <Paper className={classes.input}>
                        <CboCentrosMedicos 
                            manejadorInputChange={handleInputChangeCascada}
                            idCombo={'idCentroMedico'}
                            filtrarPorUsuario={true}
                            valor={idCentroMedico}
                            required={[]}
                        />
                    </Paper>
                </Grid>
                <Grid item xs={12} md={4}>
                    <Paper className={classes.input}>
                        <CboProfesionales 
                            manejadorInputChange={handleInputChangeCascada}
                            idCentroMedico={idCentroMedico}
                            cargarEnCascada={true}
                            porCentroMedico={true}
                            valor={idProfesional}
                        />
                    </Paper>
                </Grid>
                <Grid item xs={12} md={4}>
                    <Paper className={classes.input}>
                        <CboEspecialidades
                            manejadorInputChange={handleInputChangeCascada}
                            setIdEspecialidad={setIdEspecialidad}
                            idCentroMedico={idCentroMedico}
                            idProfesional={idProfesional}
                            cargarEnCascada={true}
                            valor={idEspecialidad}
                            cargarHorarios={true}
                            required={[]}
                        />
                    </Paper>
                </Grid>
                <Grid item xs={12} md={4}>
                    <Paper className={classes.input}>
                        <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
                            <KeyboardDatePicker
                                margin="normal"
                                label="Fecha Desde"
                                format="dd/MM/yyyy"
                                required={true}
                                clearLabel="Limpiar"
                                cancelLabel="Cancelar"
                                value={
                                    moment(fechaDesde).isValid()
                                    ? moment(fechaDesde)
                                    : 0
                                }
                                onChange={(date) => {
                                    setearValor("fechaDesde", date);
                                }}
                                KeyboardButtonProps={{
                                    "aria-label": "change date",
                                }}
                            />
                        </MuiPickersUtilsProvider>
                    </Paper>  
                </Grid>
                <Grid item xs={12} md={4}>
                    <Paper className={classes.input}>
                        <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
                            <KeyboardDatePicker
                                margin="normal"
                                label="Fecha Hasta"
                                format="dd/MM/yyyy"
                                required={true}
                                clearLabel="Limpiar"
                                cancelLabel="Cancelar"
                                value={
                                    moment(fechaHasta).isValid()
                                    ? moment(fechaHasta)
                                    : 0
                                }
                                onChange={(date) => {
                                    setearValor("fechaHasta", date);
                                }}
                                KeyboardButtonProps={{
                                    "aria-label": "change date",
                                }}
                            />
                        </MuiPickersUtilsProvider>
                    </Paper>  
                </Grid>
                <Grid item xs={12} md={4}>
                    <Paper style={{padding: 28, textAlign: 'center'}}>
                        <Button
                            variant="contained"
                            color="primary"
                            type='submit'
                        >
                            Consultar
                        </Button>
                    </Paper>
                </Grid>
            </Grid>
        </>
     );
}